<script>
    import VueContentLoading from 'vue-content-loading';

    export default {
        components: {
            VueContentLoading,
        },
    };
</script>

<template>
    <vue-content-loading :width="300" :height="72">
        <rect x="20" y="2" rx="4" ry="4" width="170" height="12" />
        <rect x="20" y="22" rx="4" ry="4" width="230" height="12" />
        <rect x="20" y="42" rx="4" ry="4" width="100" height="12" />
    </vue-content-loading>
</template>
